<template>
<div>
    <div class="box-header title-boreder">
      <h3 class="box-title title">Servicio de Distribución</h3>
    </div>
  <div class="box box-success">
    <div class="box-header title-boreder">
      <h3 class="box-title box-title-sub">
        <img src='/static/img/icons/search.png' style="padding-bottom:7px"> BUSCAR SERVICIO DE DISTRIBUCIÓN</h3>
    </div>
    <div class="box-body">
      <div class="filterContainer" v-if="this.optionsAccount.length > 1">
        <div class="col-md-3">
          <div id="divAccountSelect" class="form-group">
            <label>Cuenta</label>  
            <multiselect
              :value="this.selectedAccount"
              selectLabel=""
              selectedLabel=""
              deselectLabel=""
              track-by="name"
              :placeholder="this.selectedAccount.name"
              :allow-empty="false"
              label="name"
              :options="this.optionsAccount"
              @input="onAccountSelect">
              <span slot="noResult">
                No se encontraron resultados
              </span>
            </multiselect>
          </div>
        </div>
        <!-- Filtro BÚSQUEDA Docuento -->
        <div class="form-group col-md-3 documentSearch">
            <label>Documento:</label>              
            <input type="text" v-model="tableFilter" v-on:keyup="filterTruck" @paste="filterTruck" class="form-control">
            
            <button class="btn btn-success" @click="clearFilter" v-if="this.tableFilter !== ''"><i class="fa fa-times"></i></button>   
          </div><button class="btn btn-success" style="margin:24px; width:100px" v-on:click="loadDataButton()">Buscar</button>
      </div>

    </div>
  </div>
  <div class="box box-success">
    <div class="box-header title-boreder">
      <h3 class="box-title box-title-sub">
        <img src='/static/img/icons/result.png' style="padding-bottom:7px;"> RESULTADO BÚSQUEDA</h3>
    </div>
    <div class="box-body">
          <!-- Tabla  -->
          <div  id="truckTable" >
              <vuetable 
                id="truckTable"
                ref="vuetable"
                :api-mode="false"
                :fields="tableFields"
                :data="tableData"
                :css="tableCSS.table"
                @vuetable:loading="onLoading"        
                @vuetable:loaded="onLoaded"
                noDataTemplate="No se encontraron resultados"
                :data-manager="dataManager"
                pagination-path="pagination"
                @vuetable:pagination-data="onPaginationData"
                :key="tableKey"
                :per-page="7"
              >
                  <template slot="company" slot-scope="props">
                    <div id="Empresa">
                       <img v-if="window.width > 600" src='/static/img/icons/ic_car.png' style="padding-bottom:7px;"> 
                        {{props.rowData.company}} 
                    </div>
                 </template>

              <template slot="plate" scope="props">
                <div id="Placa">
                  <span >{{props.rowData.plate}}</span>
                </div>
              </template>

              <template slot="shippedDocuments" scope="props">
                <div id="Desp.">
                  <span >{{props.rowData.shippedDocuments}}</span>
                </div>
              </template>

              
              <template slot="totalDocuments" scope="props">
                <div id="Total">
                  <span >{{props.rowData.totalDocuments}}</span>
                </div>
              </template>

                 <template slot="percentage" slot-scope="props">
                    <div :style="'display: inline-flex;'">
                      <div :style="'font-size: 18px;margin:0 10px'">{{props.rowData.percentageShipped | formatDecimal}}%</div>
                        <div class="progressContainer text-center">
                        <div class="progressBar" :style="'position:inherit'">
                          <div class="progress table-bar" :style="'background-color:#D9DEFB;'">
                            <div :class="'progress-bar progress-bar'" role="progressbar"
                              aria-valuemin="0" aria-valuemax="100" :style="'background-color:#536DFE;width:' + props.rowData.percentageShipped + '%'">
                            </div>
                          </div>
                        </div>
                      </div>
                  </div>
                 </template>
                 <template slot="detail" scope="props">
                    <button class="btn table-btn" v-on:click="onRowClick(props.rowData)">
                      <img v-if="window.width > 1000" src='static\img\icons\loc_arrow.png' ><span v-if="false">{{props.rowData.percentageShipped}}</span>
                    </button>
                     <div class="text-center botonVerDetalle">
                        <span v-if="window.width < 1000" style=" color:#364A5D; font-size:14px;font-weight: bold;" v-on:click="onRowClick(props.rowData)">Ver detalles</span>
                    </div>
                 </template>
              </vuetable>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <vuetable-pagination ref="pagination"
                :css="tableCSS.pagination"
                @vuetable-pagination:change-page="onChangePage"
              ></vuetable-pagination>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <br/>
            </div>
          </div>
        </div>

        <!-- Modal Detalle -->
    <modal id="truck" name="truck" v-bind:click-to-close="false">
           <div class="box-header title-boreder" style="height:60px !important">
             <!-- Titulo < 600 -->
           <div v-if="window.width < 600" class="box-title box-title-sub">
            <img src="/static/img/icons/ic_location.png" style="padding-bottom: 6px; padding-right: 8px;"> <span style="font-size:12px !important;">Servicio de Distribución</span>
           </div>

          <div class="box-title box-title-sub"  v-if="window.width > 600">
            <img src="/static/img/icons/ic_location.png" style="padding-bottom: 6px; padding-right: 8px;"> <span>Servicio de Distribución - {{this.selectedTruck === null ? 0 : this.selectedTruck.company}}</span>
           </div>

            <button  type="button" class="close" data-dismiss="modal" aria-label="Close" v-on:click="showAllTrucks()" style="padding:5px;" >
              <span aria-hidden="true">&times;</span>
            </button>
      </div>
      <div>
                    <gmap-map
                    :center="center"
                    :zoom="zoom"
                    style="width:100%;  height: 300px;"
                  >
                    <gmap-marker
                      :key="index"
                      v-for="(m, index) in markers"
                      :position="m.position"
                      @click="onTruckSelect(m)"
                      icon="/static/img/icons/ic_truck_50.png"
                    ></gmap-marker>
                  </gmap-map>
                  </div>
                  <div class="col-md-12" style="margin:0 80px">
                    <div class="centroModal" style="display:inline-flex"> 
                      <div style="margin: 0 0px; width:300px">
                        <h4 style="font-weight: bold;color:#70869A">Empresa</h4>
                        <p style="color:#70869A">{{this.selectedTruck === null ? 0 : this.selectedTruck.company }}</p>
                      </div>
                          <div>
                      <h4 style="font-weight: bold;color:#70869A">PLACA</h4>
                      <div class="callout callout-success" 
                      style="width: 80px;
                      height: 30px;
                      padding-left: 10px;
                      padding-right: 10px;
                      border-left-width: 0px;
                      margin-bottom: 0px;
                      background-color: rgb(83, 109, 254) !important;
                      padding-top: 5px;
                      padding-bottom: 5px;">
                        <h4 style="font-weight : normal !important;">{{this.selectedTruck === null ? 'asd' : this.selectedTruck.plate}}</h4>
                      </div>
                  </div>
                  <div class="porcentajeModal" style="margin:0px 80px -30px">
                    <div style="margin: 30px -10px 20px; display: inline-flex">
                      <h3 style="margin: -3px 10px !important;color:#70869A">{{(this.chartData === null ? 0 : this.chartData.centerTextValue) | formatDecimal}}%</h3>
                  <div class="progressContainer text-center">
                            <div class="progressBar">
                              <div class="progress table-bar" :style="'background-color:#D9DEFB;height: 20px !important;width: 200px !important'">
                                <div :class="'progress-bar progress-bar'" role="progressbar"
                                  aria-valuemin="0" aria-valuemax="100" :style="'background-color:#536DFE;width:' +(this.chartData === null ? 0 : this.chartData.centerTextValue)+ '%'">
                                </div>
                              </div>
                            </div>
                          </div>
                      </div>
                    </div>
                
                  </div>

               
                
                  <div style="width: 200px;margin-top: 10px; margin-left: 530px" class="center-block">
                    <div style="width: 100px; border-right:1px solid #eee;" class="pull-left text-center">
                      <img src="/static/img/icons/camion.png" style="vertical-align: text-bottom" alt="Ingresadas" height="20" width="22">
                      <span class="span-value" v-bind:style="{color: this.chartColors.solid}">
                        {{this.fetchData.shippedDocuments}}
                      </span>
                      <br/>
                      <span class="span-status">Despachados</span>
                    </div>
                    <div style="width: 100px;" class="pull-right text-center">
                    <img src="/static/img/icons/proyectado.png" style="vertical-align: text-bottom" alt="Ingresadas" height="18" width="18">
                      <span class="span-value" v-bind:style="{color: this.colorProjected}">
                        {{this.fetchData.totalDocuments}}
                      </span>
                      <br/>
                      <span class="span-status">Proyectado</span>
                    </div>
                  </div> 
              </div>
    </modal>
        <!-- Fin Modal -->

        </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import { Vuetable, VuetablePagination } from 'vuetable-2'
import DoughnutChart from 'charts/DoughnutChart.js'
import util from 'assets/js/util.js'
import constants from 'assets/js/constants.js'
import { loadGmapApi, gmapApi } from 'vue2-google-maps'

export default {
  name: 'DispatchTracking',
  data () {
    return {
      intervalTime: 120000, // 2 Minutes
      interval: null,
      loader: null,
      optionsAccount: null,
      selectedTruck: null,
      selectedAccount: null,
      tableKey: 0,
      window: {
        width: 0,
        height: 0
      },
      tableData: null,
      tableFields: [
        {
          name: '__slot:company',
          title: 'Empresa'
        },
        {
          name: '__slot:plate',
          title: 'Placa'
        },
        {
          name: '__slot:shippedDocuments',
          title: 'Desp.'
        },
        {
          name: '__slot:totalDocuments',
          title: 'Total'
        },
        {
          name: '__slot:percentage',
          title: ''
        },
        {
          name: '__slot:detail',
          title: ''
        }
      ],
      tableCSS: null,
      tableOptions: {
        filterable: false,
        texts: {
          count: ''
        }
      },
      loadCurrentPage: false,
      currentPage: 0,
      tableFilter: '',
      zoom: null,
      zoomDefault: 10,
      centerDefault: {
        lat: -12.046374,
        lng: -77.042793
      },
      center: null,
      markers: [],
      fetchData: null,
      chartData: null,
      chartColors: {
        solid: '',
        opaque: ''
      },
      colorProjected: ''
    }
  },
  components: {
    Multiselect,
    Vuetable,
    'vuetable-pagination': VuetablePagination,
    'chart-progress': DoughnutChart
  },
  computed: {
    google: gmapApi,
    ...mapGetters([
      'userClients'
    ])
  },
  beforeMount () {
    loadGmapApi({
      key: constants.apiKeyGoogle.vitz
    })
  },
  created () {
    this.tableCSS = constants.tableCSS
    this.zoom = this.zoomDefault
    this.center = this.centerDefault
    this.colorProjected = constants.colorPalette.Projected
    this.optionsAccount = Array.from(this.userClients)
    this.selectedAccount = this.optionsAccount[0]
    this.loadData()
  },
  mounted () {
    this.geolocate()
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  methods: {
    ...mapActions([
      'fetchDispatchVehicleList',
      'fetchDispatchVehicleLocation'
    ]),
    handleResize () {
      this.window.width = window.innerWidth
      this.window.height = window.innerHeight
    },
    loadDataButton () {
      this.center = this.centerDefault

      this.loader = this.$loading.show({
        loader: 'dots'
      })

      this.fetchDispatchVehicleList(this.selectedAccount.code)
      .then((data) => {
        if (data != null) {
          this.fetchData = data

          this.loadMarkersData()
          this.loadTableData()

          this.loader.hide()
        }
      })
    },
    loadData () {
      this.center = this.centerDefault

      this.loader = this.$loading.show({
        loader: 'dots'
      })

      this.fetchDispatchVehicleList(this.selectedAccount.code)
      .then((data) => {
        if (data != null) {
          this.fetchData = data

          this.loadMarkersData()
     /*      this.loadTableData() */

          this.loader.hide()
        }
      })
    },
    loadMarkersData () {
      this.markers = this.fetchData.vehicles.map(item => ({
        plate: item.plate,
        company: item.company,
        position: {
          lat: item.latitude,
          lng: item.longitude
        }
      }))
    },
    loadTableData () {
      let filter = this.tableFilter

      if (filter !== '') {
        let filterData = this.fetchData.vehicles.filter(function (vehicle) {
          let re = new RegExp(filter, 'g')
          return vehicle.documents.filter(item => item.documentNumber.match(re)).length > 0
        })

        this.tableData = {
          data: filterData.map(item => ({
            plate: item.plate,
            company: item.company,
            totalDocuments: item.totalDocuments,
            shippedDocuments: item.shippedDocuments
          }))
        }
      } else {
        this.tableData = {
          data: this.fetchData.vehicles.map(item => ({
            plate: item.plate,
            company: item.company,
            totalDocuments: item.totalDocuments,
            shippedDocuments: item.shippedDocuments,
            percentageShipped: item.shippedDocuments === 0 ? 0 : (item.shippedDocuments * 100) / item.totalDocuments
          }))
        }
      }
      this.tableKey++
    },
    /* DropDownList Events */
    onAccountSelect (account) {
      this.selectedTruck = null
      this.tableFilter = ''
      this.currentPage = 0
      this.clearInterval()
      this.selectedAccount = account
      this.loadData()
    },
    /* Table Events */
    onLoading () {
      if (!this.loader) {
        this.loader = this.$loading.show({
          loader: 'dots'
        })
      }
    },
    onLoaded () {
      this.loader.hide()

      if (this.loadCurrentPage && this.currentPage !== 1) {
        this.$refs.vuetable.changePage(this.currentPage)
        this.loadCurrentPage = false
      }
    },
    onRowClick (row) {
      let selectedTruck = this.markers.filter(item => item.plate === row.plate)[0]
      if (selectedTruck) {
        this.onTruckSelect(selectedTruck)
      }
    },
    filterTruck (event) {
      this.loadTableData()
    },
    /* Table Methods */
    clearFilter () {
      this.tableFilter = ''
      this.loadTableData()
    },
    /* Table Pagination */
    onPaginationData (paginationData) {
      this.$refs.pagination.setPaginationData(paginationData)
    },
    onChangePage (page) {
      this.$refs.vuetable.changePage(page)
      this.currentPage = page
    },
    dataManager (sortOrder, pagination) {
      let data = []

      if (this.tableData) {
        data = this.tableData.data

        pagination = this.$refs.vuetable.makePagination(data.length)
        data = data.slice(pagination.from - 1, pagination.to)
      } else {
        pagination = this.$refs.vuetable.makePagination(0)
      }

      return {
        pagination: pagination,
        data: data
      }
    },
    /* Map Methods */
    geolocate: function () {
      navigator.geolocation.getCurrentPosition(position => {
        this.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        }
      })
    },
    /* Map Events */
    onTruckSelect (marker) {
      this.$modal.show('truck')
      this.selectedTruck = marker
      this.markers = [this.selectedTruck]
      this.center = this.selectedTruck.position
      this.zoom = 14
      this.loadChartData()

      this.interval = setInterval(() => { this.getTruckLocation() }, this.intervalTime)
    },
    /* Detail Events */
    showAllTrucks () {
      this.$modal.hide('truck')
      this.clearInterval()
      this.selectedTruck = null
      this.loadMarkersData()
      this.center = this.centerDefault
      this.zoom = this.zoomDefault
      this.loadCurrentPage = true
    },
    /* Detail Methods */
    loadChartData () {
      let truckOrdersData = this.getSelectedTruckValues()
      let chartPecentage = 0

      if (truckOrdersData.shippedDocuments > 0 && truckOrdersData.totalDocuments) {
        chartPecentage = (100 * truckOrdersData.shippedDocuments) / truckOrdersData.totalDocuments
      }

      this.chartColors = util.getChartColors(chartPecentage)

      this.chartData = {
        centerTextValue: chartPecentage,
        centerTextColor: this.chartColors.solid,
        labels: [
          'Entregado',
          'Restante'
        ],
        datasets: [
          {
            data: [
              truckOrdersData.shippedDocuments,
              truckOrdersData.totalDocuments - truckOrdersData.shippedDocuments
            ],
            backgroundColor: [
              this.chartColors.solid,
              this.chartColors.opaque
            ]
          }
        ]
      }

       // update center value
      if (this.$refs.chartProgress) {
        this.$refs.chartProgress.update(percentage, chartColors.solid)
      }
    },
    getSelectedTruckValues () {
      return this.tableData.data.filter(item => item.plate === (this.selectedTruck === null ? 'a' : this.selectedTruck.plate))[0]
    },
    getTruckLocation () {
      let truckIndex

      for (let index = 0; index < this.fetchData.vehicles.length; index++) {
        if (this.selectedTruck.plate === this.fetchData.vehicles[index].plate) {
          truckIndex = index
        }
      }

      this.fetchDispatchVehicleLocation(this.selectedTruck.plate)
      .then((data) => {
        if (data != null) {
          // Updates Marker
          this.markers = data.vehicles.map(item => ({
            plate: item.plate,
            company: item.company,
            position: {
              lat: item.latitude,
              lng: item.longitude
            }
          }))

          // Updates Fetch Data with new Geo
          this.selectedTruck = this.markers[0]
          this.fetchData.vehicles[truckIndex].latitude = this.selectedTruck.position.lat
          this.fetchData.vehicles[truckIndex].longitude = this.selectedTruck.position.lng
        }
      })
    },
    clearInterval () {
      if (this.interval !== null) {
        clearInterval(this.interval)
      }
    }
  },
  destroyed () {
    if (this.loader !== null) {
      this.loader.hide()
    }

    this.clearInterval()
  }
}
</script>

<style>

.v--modal-overlay{
  z-index: 100000 !important;
}

.v--modal{
   width: 1000px !important;
   height: 534px !important;
   position: absolute;
   left: 50%;
   top: 50%; 
   margin-left: -180px;
   margin-top: -120px;
}

/* #truckTable tbody tr {
  cursor: pointer;
} */

#truckTable table thead th{
    padding: 20px 20px 10px 10px;
    }

#map {
  height: 100%;
}

#truckTable td {
padding: 20px !important
}

.botonVolver{
  float: right !important;
  left: 250px !important;
  top: -50px !important;
  margin-top: 20px;
}

.botonVolver2{
 display: none !important;
}

@media screen and (max-width: 1000px) {

.documentSearch{
  margin-top: 41px !important;
}

.v--modal{
  height: 600px !important;
  width: 600px !important;
  left: 30% !important;
  top: 30% !important;    
} 

.centroModal{
  display: block !important;
  margin-left: -72px !important;
}

.porcentajeModal{
  margin-left: 0 !important; 
}

.botonVolver{
  margin-top: -30px !important;
}

   #truckTable table {
      border: 0;
    }

   #truckTable table thead {
      display: none;
    }

   #truckTable table tr {
      margin-top: 10px !important;
      margin-bottom: 20px !important;
	    border:  3px solid;
      border-color:#F2F4F6 !important;
      background-color: white !important;
      display: block !important;
    }

   #truckTable table td {
      display: block;
      border: none !important;
      font-size: 13px;
      text-align: right;
      padding: 3px !important;
      padding-right: 10px !important;
      padding-left: 10px !important;
    }

   #truckTable table td:last-child {
      border-bottom: 0;
    }

    #truckTable table td div::before{
      content: attr(id);
      float: left;
      text-transform: uppercase;
      font-weight: bold;
    }
    	#truckTable	tbody{
			line-height:0!important;
		}

    .table-btn {
    float: none !important;
    background: none !important;
}

.botonVerDetalle{
    border-top: solid 2px!important;
    margin-top: 10px;
    border-color:#F2F4F6 !important;
    padding: 10px;
    cursor: pointer;
 }

}

@media screen and (max-width: 650px) {


 
.v--modal{
  height: 500px !important;
  width: 300px !important;
  left: 60% !important;
  }


.botonVolver2{
  margin-top: 20px !important;
  display: block !important;
}


  #Porcentaje{
    display: contents !important;
  }
  
  .close{
    top: 0px !important;
    position: relative !important;
  }

  .vuetable-empty-result{
    text-align: center !important;
  }



  }
</style>



// WEBPACK FOOTER //
// DispatchTracking.vue?7dffd95e